var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:'webboard-thread-list'},_vm._l((_vm.messages),function(message,index){return _c('li',{key:String(message.id)},[_vm._v(" "+_vm._s(index)+" "+_vm._s(message)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }